<section class="tipo-operacao">
  <h2 class="tipo-operacao__title">Simular para:</h2>

  <div class="tipo-operacao__options">
    <app-button-selector
      *ngFor="let item of tiposClientes"
      [data]="item"
      [(selected)]="tipoCliente"
      (selectedChange)="onTipoClienteChange()"
    >
    </app-button-selector>
  </div>
</section>
